import React from "react";

function Calculator({ onKeyPress, showLetters, setShowLetters, context }) {
  const numbers =
    context === "numeric"
      ? Array.from("123456789-0.")
      : Array.from("123456789-0_");
  const letters = Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ");
  const keysToShow = showLetters ? letters : numbers;

  const handleKeyClick = (key) => {
    onKeyPress(key);
  };

  return (
    <div className="pos-calc-container">
      <div
        className="pos-calc-grid"
        style={{
          /* Changed fixed pixels to 1fr fractional units to allow fluid auto-shrinking */
          gridTemplateColumns: showLetters
            ? "repeat(6, 1fr)"
            : "repeat(3, 1fr)",
        }}
      >
        {keysToShow.map((key) => (
          <button
            className="btn btn-secondary"
            key={key}
            onClick={() => handleKeyClick(key)}
          >
            {key}
          </button>
        ))}
        <button onClick={() => handleKeyClick("C")}>C</button>
        <button onClick={() => handleKeyClick("←")}>←</button>
        <button
          className="toggle-keyboard"
          onClick={() => setShowLetters(!showLetters)}
          title={showLetters ? "Clavier numérique" : "Clavier alphabétique"}
        >
          <i className="fa fa-keyboard"></i>
        </button>
      </div>
    </div>
  );
}

export default Calculator;
